/** Skeleton shown while a lazy route chunk loads. Phase 2 replaces with a richer skeleton. */
export function RouteFallback(): JSX.Element {
  return (
    <div role="status" aria-live="polite" style={{ padding: 24 }}>
      <span style={{ color: 'var(--pfl-text-mute)', fontSize: 'var(--fs-12)' }}>Loading…</span>
    </div>
  );
}
